import {Viewer} from "./Viewer"

export function App() {
  return <Viewer />
}
